// Written in this round about way for babel-transform-imports
import Route from 'react-router/es/Route';

export default Route;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.4.2.2@react-router-dom/es/Route.js
// module id = 245
// module chunks = 1